import React, { useEffect, useState } from "react";
import { loadAppSettingsHybrid, saveAppSettings } from "../services/data";

export default function SettingsPage({ user, onBack }) {
  const [tab, setTab] = useState("general");
  const [form, setForm] = useState({
    branding: { name: "Form2Doc", primaryColor: "#10b981" },
    i18n: { default: "fr" },
    default_currency: "MAD",
    appearance: { theme: "auto" },
  });

  useEffect(() => {
    if (!user?.uid) return;
    const unsub = loadAppSettingsHybrid(user.uid, (live) => {
      if (live) {
        setForm((prev) => ({ ...prev, ...live }));
      }
    });
    return () => unsub && unsub();
  }, [user?.uid]);

  const upd = (path, value) => {
    setForm((prev) => {
      const next = structuredClone(prev);
      const parts = path.split(".");
      let cur = next;
      for (let i = 0; i < parts.length - 1; i += 1) {
        const key = parts[i];
        cur[key] = cur[key] || {};
        cur = cur[key];
      }
      cur[parts[parts.length - 1]] = value;
      return next;
    });
  };

  const TabButton = ({ id, icon, label }) => (
    <a
      href={"#" + id}
      className={`settings-nav-link ${tab === id ? "active" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        setTab(id);
      }}
    >
      <i className={icon}></i>
      {label}
    </a>
  );

  const onSave = async () => {
    if (!user?.uid) return;
    await saveAppSettings(user.uid, form);
    alert("Parametres enregistres.");
  };
  const onReset = () => window.location.reload();

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fas fa-sliders-h"></i>
          Paramètres
        </h1>
        <div className="page-actions">
          {onBack && (
            <button className="btn btn-outline" onClick={onBack}>
              <i className="fas fa-arrow-left"></i> Retour
            </button>
          )}
          <button className="btn btn-outline" onClick={onReset}>
            <i className="fas fa-history"></i> Réinitialiser
          </button>
          <button className="btn btn-primary" onClick={onSave}>
            <i className="fas fa-save"></i> Enregistrer
          </button>
        </div>
      </div>

      <div className="settings-container">
        {/* Sidebar */}
        <aside className="settings-sidebar">
          <ul className="settings-nav">
            <li className="settings-nav-item">
              <TabButton id="general" icon="fas fa-cog" label="Général" />
            </li>
            <li className="settings-nav-item">
              <TabButton
                id="notifications"
                icon="fas fa-bell"
                label="Notifications"
              />
            </li>
            <li className="settings-nav-item">
              <TabButton id="appearance" icon="fas fa-palette" label="Apparence" />
            </li>
            <li className="settings-nav-item">
              <TabButton id="security" icon="fas fa-shield-alt" label="Sécurité" />
            </li>
            <li className="settings-nav-item">
              <TabButton
                id="integrations"
                icon="fas fa-plug"
                label="Intégrations"
              />
            </li>
            <li className="settings-nav-item">
              <TabButton id="advanced" icon="fas fa-tools" label="Avancé" />
            </li>
          </ul>
        </aside>

        {/* Content */}
        <section className="settings-content">
          {/* Général */}
          {tab === "general" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-cog"></i> Paramètres généraux
                </h3>
              </div>
              <div className="section-body">
                <form className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Nom de l’application</label>
                    <input
                      className="form-input"
                      value={form.branding?.name || ""}
                      onChange={(e) => upd("branding.name", e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Langue par défaut</label>
                    <select
                      className="form-select"
                      value={form.i18n?.default || "fr"}
                      onChange={(e) => upd("i18n.default", e.target.value)}
                    >
                      <option value="fr">Francais</option>
                      <option value="en">English</option>
                      <option value="ar">Arabe</option>
                      <option value="ru">Russe</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Devise par defaut</label>
                    <select
                      className="form-select"
                      value={form.default_currency || "MAD"}
                      onChange={(e) => upd("default_currency", e.target.value)}
                    >
                      <option value="MAD">MAD</option>
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fuseau horaire</label>
                    <input className="form-input" defaultValue="Africa/Casablanca" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Format de date</label>
                    <select className="form-select" defaultValue="DD/MM/YYYY">
                      <option>DD/MM/YYYY</option>
                      <option>YYYY-MM-DD</option>
                      <option>MM/DD/YYYY</option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Notifications */}
          {tab === "notifications" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-bell"></i> Notifications
                </h3>
              </div>
              <div className="section-body">
                <div className="setting-item">
                  <div className="setting-info">
                    <div className="setting-title">Emails de suivi</div>
                    <div className="setting-desc">Recevoir un récap hebdo.</div>
                  </div>
                  <label className="switch">
                    <input type="checkbox" defaultChecked />
                    <span className="slider"></span>
                  </label>
                </div>
                <div className="setting-item">
                  <div className="setting-info">
                    <div className="setting-title">Alertes en temps réel</div>
                    <div className="setting-desc">Toast/bannière dans l’app.</div>
                  </div>
                  <label className="switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* Apparence */}
          {tab === "appearance" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-palette"></i> Apparence
                </h3>
              </div>
              <div className="section-body">
                <form className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Thème</label>
                    <select
                      className="form-select"
                      value={form.appearance?.theme || "auto"}
                      onChange={(e) => upd("appearance.theme", e.target.value)}
                    >
                      <option value="auto">Auto</option>
                      <option value="light">Clair</option>
                      <option value="dark">Sombre</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Couleur primaire</label>
                    <input className="form-input" type="color" defaultValue="#4361ee" />
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Sécurité */}
          {tab === "security" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-shield-alt"></i> Sécurité
                </h3>
              </div>
              <div className="section-body">
                <div className="setting-item">
                  <div className="setting-info">
                    <div className="setting-title">
                      Double authentification (2FA)
                    </div>
                    <div className="setting-desc">
                      Renforce l’accès au compte via OTP.
                    </div>
                  </div>
                  <label className="switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
                <div className="form-actions" style={{ marginTop: 20 }}>
                  <button className="btn btn-outline">
                    <i className="fas fa-key"></i> Réinitialiser le mot de passe
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Intégrations */}
          {tab === "integrations" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-plug"></i> Intégrations
                </h3>
              </div>
              <div className="section-body">
                <div className="integration-item">
                  <div className="integration-icon">
                    <i className="fas fa-database"></i>
                  </div>
                  <div className="integration-info">
                    <div className="integration-name">Firebase</div>
                    <div className="integration-desc">
                      Connexion Firestore/Storage.
                    </div>
                  </div>
                  <span className="status-badge status-active">Actif</span>
                </div>
                <div className="integration-item">
                  <div className="integration-icon">
                    <i className="fas fa-cloud"></i>
                  </div>
                  <div className="integration-info">
                    <div className="integration-name">Drive/OneDrive</div>
                    <div className="integration-desc">
                      Export/backup de documents.
                    </div>
                  </div>
                  <span className="status-badge status-inactive">Inactif</span>
                </div>
              </div>
            </div>
          )}

          {/* Avancé */}
          {tab === "advanced" && (
            <div className="settings-section">
              <div className="section-header">
                <h3 className="section-title">
                  <i className="fas fa-tools"></i> Avancé
                </h3>
              </div>
              <div className="section-body">
                <div className="setting-item">
                  <div className="setting-info">
                    <div className="setting-title">Zone dangereuse</div>
                    <div className="setting-desc">Actions irréversibles.</div>
                  </div>
                  <div className="setting-control">
                    <button className="btn btn-danger">
                      <i className="fas fa-trash"></i> Purger le cache local
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
